import { render, staticRenderFns } from "./BritishHeartFoundation.vue?vue&type=template&id=6ef46bf6&scoped=true&"
import script from "./BritishHeartFoundation.vue?vue&type=script&lang=js&"
export * from "./BritishHeartFoundation.vue?vue&type=script&lang=js&"
import style0 from "./BritishHeartFoundation.vue?vue&type=style&index=0&id=6ef46bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef46bf6",
  null
  
)

export default component.exports